import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components/macro';
import CloseIcon from '../../resources/Close.svg';
import { RedButton } from '../../components/Button';

interface Props {
	handleModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const SalesModal = ({ handleModal }: Props) => {
	const containerRef = React.useRef<HTMLDivElement>(null);

	const closeSalesModal = useCallback(() => {
		handleModal(true);
	}, [handleModal]);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
				closeSalesModal();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [closeSalesModal]);

	return (
		<>
			<StyledModal>
				<Container ref={containerRef}>
					<UpperContainer>
						<StyledCloseButton src={CloseIcon} onClick={closeSalesModal} />
					</UpperContainer>
					<LowerContainer>
						<StyledHeading>
							{'Welcome to the updated payment portal! '}
							<br />
							<br />
							{
								"What's new? Besides a new look, we're calculating sales tax for you. Plus, you'll see a new sales tab corresponding to the sales totals uploaded to your financial form at the end of the Fair."
							}
						</StyledHeading>
						<StyledButtonContainer>
							<StyledRedButton handleClick={closeSalesModal}>Get Started</StyledRedButton>
						</StyledButtonContainer>
					</LowerContainer>
				</Container>
			</StyledModal>
		</>
	);
};

const StyledModal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2000;
`;

const Container = styled.div`
	display: flex;
	position: fixed;
	top: 30px;
	left: 50%;
	transform: translateX(-50%);
	width: 600px;
	height: fit-content;
	padding: 16px 16px 20px 16px;
	flex-direction: column;
	align-items: center;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0px 7px 14px 0px rgba(0, 0, 0, 0.2);
	@media (max-width: 700px) {
		width: calc(100% - 80px);
	}
`;

const UpperContainer = styled.div`
	display: flex;
	padding-bottom: 20px;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;
`;

const LowerContainer = styled.div`
	display: flex;
	width: 568px;
	padding: 4px 0px 24px 0px;
	flex-direction: column;
	align-items: center;
	gap: 60px;
	@media (max-width: 440px) {
		gap: 40px;
	}
`;

const StyledHeading = styled.p`
	color: #333333;
	text-align: center;
	font-size: 21px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
	width: 352px;
	@media (max-width: 440px) {
		font-size: 18px;
		width: 280px;
	}
`;

const StyledCloseButton = styled.img`
	position: absolute;
	right: 16px;
	top: 16px;
	background: none;
	border: none;
	cursor: pointer;
	height: 16px;
	width: 16px;
`;

const StyledButtonContainer = styled.div`
	display: flex;
	width: 280px;
	justify-content: center;
	align-items: center;
	gap: 32px;
	@media (max-width: 440px) {
		gap: 10px;
	}
`;

const StyledRedButton = styled(RedButton)`
	width: 100%;
	@media (max-width: 440px) {
		width: 60%;
	}
`;

export default SalesModal;
